import { render, staticRenderFns } from "./NewChildMember.vue?vue&type=template&id=52319bdc&scoped=true&"
import script from "./NewChildMember.vue?vue&type=script&lang=js&"
export * from "./NewChildMember.vue?vue&type=script&lang=js&"
import style0 from "./NewChildMember.vue?vue&type=style&index=0&id=52319bdc&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52319bdc",
  null
  
)

component.options.__file = "NewChildMember.vue"
export default component.exports